/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_C2Inputs */

const en_guide_large_json_files_c2 = /** @type {(inputs: Guide_Large_Json_Files_C2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minifying, streaming, splitting, and NDJSON`)
};

const ko_guide_large_json_files_c2 = /** @type {(inputs: Guide_Large_Json_Files_C2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`압축과 스트리밍, 분할, 그리고 NDJSON`)
};

const ja_guide_large_json_files_c2 = /** @type {(inputs: Guide_Large_Json_Files_C2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`圧縮とストリーミング、分割、NDJSON`)
};

/**
* | output |
* | --- |
* | "Minifying, streaming, splitting, and NDJSON" |
*
* @param {Guide_Large_Json_Files_C2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_c2 = /** @type {((inputs?: Guide_Large_Json_Files_C2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_C2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_c2(inputs)
	if (locale === "ko") return ko_guide_large_json_files_c2(inputs)
	return ja_guide_large_json_files_c2(inputs)
});